<script>
  export default {
    name: 'NewInsureDetail',
    components: {},
    filters: {},
    mixins: [],
    props: {
      newInsure: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        
      }
    },
    computed: {
      isConditions() {
        const { newInsure } = this
        return newInsure.data && Array.isArray(newInsure.data.conditions)
      },
      isFeeList() {
        const { newInsure } = this
        return newInsure.data && Array.isArray(newInsure.data.feeList)
      }
    },
    watch: {},
    created() {
      
    },
    mounted() {},
    methods: {
      
    }
  }
</script>
<template>
  <div class="new-insure-detail">
    <div
      v-if="isConditions"
      class="new-insure-table conditions-table"
    >
      <div v-for="(condit, index) in newInsure.data.conditions" :key="index" class="row after-bd-b">
        <div class="cell after-bd-r">
          {{ condit.label }}
        </div>
        <div class="cell after-bd-r">
          {{ condit.value }}
        </div>
      </div>
    </div>
    <div
      v-if="isFeeList"
      class="new-insure-table age-fee-table"
    >
      <div class="row after-bd-b">
        <div class="cell after-bd-r">
          年龄
        </div>
        <div class="cell after-bd-r">
          续保保费
        </div>
      </div>
      <div v-for="(fee, index) in newInsure.data.feeList" :key="index" class="row after-bd-b">
        <div class="cell after-bd-r">
          {{ fee.age }}
        </div>
        <div class="cell after-bd-r">
          {{ fee.fee }}
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  @import 'variable.css';
  .new-insure-detail {
    padding: 15px;
    .new-insure-table {
      position: relative;
      text-align: center;
      &:before {
        @apply --bd-w;
        background-color: #e5e5e5;
        left: 0;
        top: 0;
      }
      &:after {
        @apply --bd-h;
        background-color: #e5e5e5;
        left: 0;
        top: 0;
      }
      .row {
        overflow: hidden;
        display: flex;
        .cell {
          display: flex;
          flex: 1;
          min-height: 34px;
          padding: 10px 8px;
          font-size: 12px;
          word-break: break-all;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .conditions-table {
      margin-bottom: 30px;
      .cell {
        &:first-child {
          background: #f8f8f8;
        }
      }
    }
    .age-fee-table {
      .row {
        &:first-child {
          .cell {
            padding: 10px 0;
            background: #f8f8f8;
          }
        }
      }
    }
  }
</style>